export default {
  padding: "15px"
};
